import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { gallery } from '../../data/site';
export function GallerySection() {
  const [first, ...rest] = gallery;
  return <section aria-labelledby="gallery-title" className="mx-auto max-w-7xl px-5 pb-24 md:px-8 md:pb-28" data-id="element-96" data-mp="7a9boq6weoo4">
      <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between" data-id="element-97" data-mp="c6zqla6yve7y">
        <h2 id="gallery-title" className="font-serif text-4xl font-medium leading-tight text-forest md:text-5xl" data-id="element-98" data-mp="3aqzlzh9ijnvm">
          En images
        </h2>
        <Link to="/realisations" className="inline-flex items-center gap-2 font-medium text-forest underline-offset-4 hover:underline" data-id="element-99" data-mp="3fmoo9scx3ivm">
          Toutes les réalisations
          <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-100" data-mp="3pgnnojllwojv" />
        </Link>
      </div>

      <div className="mt-12 grid gap-4 md:grid-cols-3 md:grid-rows-2" data-id="element-101" data-mp="2rxcgmwx8nivf">
        <figure className="md:col-span-2 md:row-span-2" data-id="element-102" data-mp="2wx8jgsu7949e">
          <img src={first.src} alt={first.alt} className="h-full min-h-[280px] w-full rounded-lg object-cover" data-id="element-103" data-mp="17urjvqavkk35" />
          <figcaption className="mt-3 text-sm text-ink-muted" data-id="element-104" data-mp="12voda1f8y5t2">{first.caption}</figcaption>
        </figure>
        {rest.map(item => <figure key={item.caption} data-id="element-105" data-mp="y3es0yp2ttx4">
            <img src={item.src} alt={item.alt} className="aspect-[3/2] w-full rounded-lg object-cover" data-id="element-106" data-mp="u3w7i4163kut" />
            <figcaption className="mt-3 text-sm text-ink-muted" data-id="element-107" data-mp="p49wm18tagp6">{item.caption}</figcaption>
          </figure>)}
      </div>
      <p className="mt-8 text-sm text-ink-muted" data-id="element-108" data-mp="k4f1fli074yb">
        Photos d’illustration. Les réalisations de Vincent Monti seront ajoutées avec la page Réalisations.
      </p>
    </section>;
}